import React, { useState } from "react";
import { Container } from "../styled.ts";
import { Typography } from "../typography/index.tsx";
import { useMobile } from "../../hooks/isMobile.tsx";

interface FAQItem {
  question: string;
  answer: string;
}

const faqItems: FAQItem[] = [
  {
    question: "Is it really free?",
    answer: "Yes! New users get a 15-day trial period for 20 stocks with unlimited alerts — completely free. After that, you get the Free Lifetime Plan to track up to 5 stocks forever with a limited set of alerts. For unlimited alerts and more than 5 stocks, you can choose from our paid plans.",
  },
  {
    question: "Will I get spam messages?",
    answer: "No spam, ever. We only send stock alerts for the stocks you choose.",
  },
  {
    question: "How do I unsubscribe?",
    answer: "After you log in, open Profile and use Deactivate your profile to stop receiving alerts.",
  },
  {
    question: "How fast are the alerts?",
    answer: "Real-time alerts delivered within seconds of company announcements. You'll know about results, orders, board meetings, and dividends instantly on WhatsApp.",
  },
  {
    question: "Do I need to download an app?",
    answer: "No app needed! Just sign up on finq.in, add stocks to your watchlist, and start receiving alerts directly on WhatsApp.",
  },
];

const FAQ = () => {
  const { isMobile } = useMobile();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <Container column gap="16px" width="100%" maxWidth="800px">
      {faqItems.map((item, index) => (
        <Container
          key={index}
          column
          border="1px solid #E0E0E0"
          radius="12px"
          padding="20px"
          style={{ cursor: "pointer" }}
          onClick={() => toggleFAQ(index)}
        >
          <Container justifyContent="space-between" alignItems="center">
            <Typography
              tag="p"
              fontFamily="Neue Montreal"
              fontSize={isMobile ? "16px" : "18px"}
              fontWeight={500}
              color="#202020"
            >
              {item.question}
            </Typography>
            <Typography
              tag="span"
              fontFamily="Neue Montreal"
              fontSize="24px"
              fontWeight={500}
              color="#5395FF"
              style={{
                transform: openIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s ease",
              }}
            >
              ▼
            </Typography>
          </Container>
          {openIndex === index && (
            <Container margin="16px 0 0 0">
              <Typography
                tag="p"
                fontFamily="Neue Montreal"
                fontSize="14px"
                fontWeight={400}
                lineHeight="22px"
                color="#828282"
              >
                {item.answer}
              </Typography>
            </Container>
          )}
        </Container>
      ))}
    </Container>
  );
};

export default FAQ;
